import { useMemo } from 'react';

import ComponentsPreview from '../components/components-preview';
import { useGetDraftLessonSections } from '../draft/activity-builder-draft.hooks';
import {
  usePagePreviewIntersectionObserver,
  usePagePreviewResizeObserver,
} from './activity-builder-page-preview.hooks';
import { getSectionsAndSubSections } from '../activity-builder.utils';
import { PagePreviewContent } from './activity-builder-page-preview-shared';
import { getContentHeight } from './activity-builder-page-preview.utils';

const ActivityBuilderPagePreviewDraft = ({
  id,
  contentId,
  contentDraftId,
  parentElement,
  initialVisibility,
}: {
  id: string;
  contentId: number;
  contentDraftId: string | null;
  parentElement?: HTMLElement | null;
  initialVisibility?: boolean;
}) => {
  const { containerRef, setContainerRef } = usePagePreviewResizeObserver();

  const { isVisible } = usePagePreviewIntersectionObserver({
    containerElement: containerRef,
    initialVisibility,
    parentElement,
  });

  const { data, loading } = useGetDraftLessonSections({
    contentDraftId,
    sectionIds: [id],
    skip: !isVisible,
  });

  const section = useMemo(
    () =>
      data?.getDraftContentSections &&
      getSectionsAndSubSections(data.getDraftContentSections).find(
        s => s.id === id
      ),
    [data?.getDraftContentSections, id]
  );

  const { pageHeight, contentHeight } = useMemo(
    () =>
      getContentHeight({
        showHeaders: false,
        includeDifferentiation: false,
      }),
    []
  );

  return (
    <PagePreviewContent
      ref={setContainerRef}
      isLoading={loading}
      dimensions={{ pageHeight, contentHeight }}
    >
      {section && <ComponentsPreview section={section} contentId={contentId} />}
    </PagePreviewContent>
  );
};

export default ActivityBuilderPagePreviewDraft;
